(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-cart-corner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function getRealAddToCartButton() {
      return document.querySelector('product-form-component [ref="addToCartButton"]');
    }

    function wireButton(root, buttonSelector, labelSelector, addedAttrHolder) {
      var button = root.querySelector(buttonSelector);
      var label = labelSelector ? root.querySelector(labelSelector) : null;
      var defaultLabel = label ? label.textContent.trim() : (button ? button.textContent.trim() : 'Add to Cart');
      var resetTimer = null;
      if (!button) return;

      function syncDisabledState() {
        var real = getRealAddToCartButton();
        if (!real) return;
        button.disabled = !!real.disabled;
      }

      syncDisabledState();
      setInterval(syncDisabledState, 1000);

      button.addEventListener('click', function () {
        var real = getRealAddToCartButton();
        if (!real || real.disabled) return;

        real.click();

        if (resetTimer) clearTimeout(resetTimer);
        addedAttrHolder.setAttribute('data-added', 'true');
        if (label) label.textContent = 'Added!';
        else button.textContent = 'Added!';

        resetTimer = setTimeout(function () {
          addedAttrHolder.removeAttribute('data-added');
          if (label) label.textContent = defaultLabel;
          else button.textContent = defaultLabel;
        }, 1500);
      });
    }

    function init() {
      var pill = document.querySelector('[data-sticky-cart-pill]');
      var desktopBar = document.querySelector('[data-sticky-cart-desktop]');

      if (pill) {
        wireButton(pill, '[data-sticky-cart-pill-button]', '[data-sticky-cart-pill-label]', pill);
      }
      if (desktopBar) {
        wireButton(desktopBar, '[data-sticky-cart-desktop-button]', null, desktopBar);
      }

      var buyBox = document.querySelector('[data-qty-breaks]');
      if (buyBox && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          var entry = entries[0];
          if (!entry) return;
          var rect = entry.target.getBoundingClientRect();
          var scrolledPast = !entry.isIntersecting && rect.bottom < 0;
          var state = scrolledPast ? 'true' : 'false';
          if (pill) pill.setAttribute('data-visible', state);
          if (desktopBar) desktopBar.setAttribute('data-visible', state);
        }, { threshold: 0 });
        observer.observe(buyBox);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var track = document.querySelector('[data-testimonial-track]');
      var prev = document.querySelector('[data-testimonial-prev]');
      var next = document.querySelector('[data-testimonial-next]');
      if (!track || !prev || !next) return;

      var scrollAmount = 280;

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });

      function updateArrows() {
        prev.disabled = track.scrollLeft <= 0;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }

      track.addEventListener('scroll', updateArrows);
      updateArrows();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
